import { render } from "./Tab.vue?vue&type=template&id=93417cee"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"
script.render = render

export default script